
import "./IframeWindow.css"
import { stateIframeWindow,statePlayerPositionS } from '../store';

const IframeWindow = ({ src, onClose }) => {
  

  const handleClose = () => {
    stateIframeWindow.showIframe = false
    stateIframeWindow.renderCanvas = true
    statePlayerPositionS.playerInput= true
  
  };

  return (
    <>
    
        <div className="iframeContainer">
          <div className="iframeContent">
            <button className="closeButton" onPointerDown={handleClose}>
              
            </button>
            <iframe  src={src} title="Iframe Window" className= "iframeWindow" />
          </div>
        </div>
  
    </>
  );
};

export default IframeWindow;